import React, { useEffect, useReducer } from 'react'
import { usePageView } from '@fs/zion-analytics'
import { useTranslation } from 'react-i18next'
import { usePageTitle } from '../app/PageTitleContext'
import { getUnit } from '../../services/membershipService'
import ObjectView from '../common/ObjectView'
import useNotifications from '../../hooks/useNotifications'

export default function notUsed() {}

export function UnitBase({ match }) {
  usePageView({ page_detail: 'DMConsole:UnitBase' })
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.unit.base'))
  const unitId = match.params.unitId
  const { unitState, unitDispatch } = useUnit()
  const { error } = useNotifications()

  const getUnitLeaders = (dmcUnitLeaders) => {
    return dmcUnitLeaders?.map((dmcUnitLeader) => {
      return {
        [`${dmcUnitLeader.mrn}_mrn`]: dmcUnitLeader.mrn,
        ...Object.fromEntries(Object.entries(dmcUnitLeader).filter(([key]) => ['email', 'phone'].includes(key))),
      }
    })
  }

  const getUnitLeadersMetadata = (dmcUnitLeaders) => {
    const leaders = {}
    dmcUnitLeaders?.forEach((dmcUnitLeader) => {
      leaders[`${dmcUnitLeader.mrn}_mrn`] = {
        name: dmcUnitLeader.fullName,
        label: t(`unit.position.${dmcUnitLeader.leaderPositionType}`, dmcUnitLeader.leaderPositionType),
      }
    })
    return leaders
  }

  useEffect(() => {
    if (unitId) {
      getUnit(unitId)
        .then((unit) => {
          unitDispatch({
            type: 'setUnit',
            payload: {
              unit,
            },
          })
        })
        .catch((err) =>
          error(
            t('unit.errors.getUnit', 'Error getting unit "{unitId}" - {message}', {
              unitId,
              message: err.message || '',
            }),
            err
          )
        )
    }
  }, [unitDispatch, unitId, error, t])

  if (!unitId) {
    return <>{t('unit.lookup', 'Look up a unit to view unit data.')}</>
  }

  if (!unitState?.unit) {
    return null
  }

  const getUnitObjectView = (unit) => {
    return (
      <ObjectView
        id={unit.type}
        object={{ ...unit, dmcUnitLeaders: null }}
        metadata={{
          leaders: getUnitLeadersMetadata(unit.dmcUnitLeaders),
          copyValueFields: ['email', 'phone'],
        }}
        expanderDetails={{ dataList: getUnitLeaders(unit.dmcUnitLeaders) }}
      />
    )
  }

  return (
    <>
      <br />
      {getUnitObjectView(unitState.unit)}
      {unitState.unit.type && !['temple', 'area'].includes(unitState.unit.type.toLowerCase()) && (
        <>
          {getUnitObjectView(unitState.parent)}
          <ObjectView object={unitState.temple} />
        </>
      )}
    </>
  )
}

function useUnit() {
  const { t } = useTranslation()

  const reducer = (oldUnitState, action) => {
    let newUnitState = JSON.parse(JSON.stringify(oldUnitState))

    if (action.type === 'setUnit') {
      newUnitState = action.payload.unit
    }
    if (newUnitState) {
      if (newUnitState?.unit) {
        newUnitState.unit.type = t(`unit.type.${newUnitState.unit.type}`, newUnitState.unit.type)
        newUnitState.unit.active = t(`${newUnitState.unit.active}`, newUnitState.unit.active)
      }
      if (newUnitState?.parent) {
        newUnitState.parent.type = t(`unit.type.${newUnitState.parent.type}`, newUnitState.parent.type)
      }
    }
    return newUnitState
  }

  const [unitState, unitDispatch] = useReducer(reducer, {})

  return { unitState, unitDispatch }
}
